import React, { useState } from 'react';
import { Map, Placemark, YMaps } from '@pbe/react-yandex-maps';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import './PageContacts.scss';
import './PageContacts-media.scss';
import FormContactsExtended from '../../components/FormContactsExtended/FormContactsExtended';
import { MediaContent } from '../../services/GlobalFunctions';
import Button from '../../components/Button/Button';
import { ContactsEkb, ContactsKazan, ContactsMsk, ContactsNn, ContactsSpb, SvgTg, SvgWhatsapp } from './constants';
import { LinkTg, MetaTags } from '../../services/content/Constants';
import Content from '../../components/Content/Content';
import { IContact, Props } from './interfaces';
import Tel from '../../components/Tel/Tel';
import MailTo from '../../components/MailTo/MailTo';
import ButtonStandalone from "../../components/Button/ButtonStandalone";

type CityKey = 'msk' | 'spb' | 'nn' | 'kazan' | 'ekb';

const CITIES: { key: CityKey; contacts: IContact }[] = [
  { key: 'msk', contacts: ContactsMsk },
  { key: 'spb', contacts: ContactsSpb },
  { key: 'nn', contacts: ContactsNn },
  { key: 'kazan', contacts: ContactsKazan },
  { key: 'ekb', contacts: ContactsEkb },
];

const PageContacts = ({ widthWindow }: Props) => {
  const [shownMaps, setShownMaps] = useState<Record<CityKey, boolean>>(() =>
    CITIES.reduce((acc, { key }) => {
      acc[key] = widthWindow > 720;
      return acc;
    }, {} as Record<CityKey, boolean>)
  );

  const openMap = (key: CityKey) => setShownMaps((prev) => ({ ...prev, [key]: true }));

  return (
    <div className="page-contacts">

      <Content
        noLazy
        block={
          <>
            <h1 className="page-contacts__title">Контакты</h1>

            <div className="page-contacts__socs">
              <div>
                <h3>Отдел продаж</h3>
                <div className="page-contacts__contact-row">
                  <Tel className={'mgo_num_msk'} phone="+7 (499) 430-32-55" tag="h4" />
                  <p>По всей России, с 9:00 до 22:00 ежедневно</p>
                </div>
                <div className="page-contacts__contact-row">
                  <Tel className={'mgo_num_spb'} phone="+7 (812) 614-35-16" tag="h4" />
                  <p>Санкт-Петербург, с 9:00 до 22:00 ежедневно</p>
                </div>
                <MailTo mail="sale@dalli-service.com" tag="h4" />
              </div>
              <div>
                <h3>Поддержка клиентов</h3>
                <div className="page-contacts__contact-row">
                  <Tel phone="+7 (499) 302-64-61" tag="h4" />
                  <p>По всей России, с 9:00 до 22:00 ежедневно</p>
                </div>
                <MailTo mail="info@dalli-service.com" tag="h4" />
              </div>
              <div>
                <h3>HR-отдел</h3>
                <p>По вопросам вакансий</p>
                <div className="page-contacts__contact-row">
                  <Tel phone="+7 (985) 674-40-50" tag="h4" />
                  <p>Москва, с 9:00 до 18:00 ежедневно</p>
                </div>
                <div className="page-contacts__contact-row">
                  <Tel phone="+7 (985) 674-40-51" tag="h4" />
                  <p>Санкт-Петербург и другие города РФ, с 9:00 до 18:00 ежедневно</p>
                </div>
              </div>
              <div>
                <h3>Для прессы и СМИ</h3>
                <MailTo mail="pr@dalli-service.com" tag="h4" />
              </div>
              <div>
                <h3>Мы в мессенджерах</h3>
                <div>
                  <a href={LinkTg} target="_blank" className="page-contacts__soc" rel="nofollow">
                    {SvgTg}
                  </a>
                  {/* <a href={LinkWhatsapp} target="_blank" className="page-contacts__soc" rel="nofollow">
                {SvgWhatsapp}
              </a> */}
                </div>
              </div>
            </div>
          </>
        }
      />

      <Content
        block={
          <div className="page-contacts__maps">
            {CITIES.map(({ key, contacts }) => (
              <div className="page-contacts__map" key={key}>
                {shownMaps[key] && MapBlock({ contacts, widthWindow })}
                {ContactInfo({
                  contacts,
                  show: shownMaps[key],
                  openMap: () => openMap(key),
                  city: key,
                })}
              </div>
            ))}
          </div>
        }
      />

      <Content block={<FormContactsExtended eventMetrika="form_contacts" />} />
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(PageContacts));

const ContactInfo = ({
  contacts: { city, phone, workingTime, address, icon },
  show,
  openMap,
  city: cityKey
}: {
  contacts: IContact;
  show: boolean;
  openMap: Function;
  city: CityKey
}) => {
  return (
    <div className={`page-contacts__info${!show ? ' page-contacts__info_hide' : ''}`}>
      <div className="page-contacts__info-city">
        {icon && <div className={`page-contacts__info-city-icon page-contacts__info-city-icon_${icon}`}></div>}
        <h3>{city}</h3>
      </div>
      {phone ? (
        <div className="page-contacts__info-phone">
          <a className={`mgo_num_${cityKey}`} href={`tel:${phone}`}>
            <h4>{phone}</h4>
          </a>
          <p>{workingTime}</p>
        </div>
      ) : (
        <p>{workingTime}</p>
      )}
      <h4>{address}</h4>

      {MediaContent(null, !show ? <Button text="Показать на карте" widthAll onClick={openMap} /> : null)}
    </div>
  );
};

export const MapBlock = ({
  contacts: { coords, linkToMap },
  widthWindow,
}: {
  contacts: IContact;
  widthWindow: number;
}) => {
  return (
    <YMaps>
      <Map state={{ center: coords, zoom: 16 }} width={`100%`} height={`560px`}>
        <Placemark geometry={coords} />
      </Map>
      <div className="page-contacts__link-to-ymaps">
        <ButtonStandalone
          text="Открыть в Яндекс.Картах"
          size="M"
          linkOut
          link={linkToMap}
          icon
          widthAll={widthWindow < 720}
        />
      </div>
    </YMaps>
  );
};
